module.exports = __webpack_public_path__ + "img/93.9c3546d1.svg";